import { RealEstateDeveloper } from '../../models/real-estate-developer.model';

export const REAL_ESTATE_DEVELOPERS_MOCK: RealEstateDeveloper[] = [
  {
    contacts: [{
      email: 'john.doe@example.com',
      jobTitle: 'Sales Manager',
      lastName: 'Doe',
      name: 'John',
      phoneNumber: '+1234567890',
    }],
    createdAt: new Date(),
    id: 1,
    legalName: 'DesarroMex S.A. de C.V.',
    logoUrl: 'https://picsum.photos/id/40/500',
    name: 'DesarroMex',
    tags: ['featured'],
    updatedAt: new Date(),
  },
  {
    contacts: [{
      email: 'jane.smith@example.com',
      jobTitle: 'Sales Manager',
      lastName: 'Smith',
      name: 'Jane',
      phoneNumber: '+1234567890',
    }],
    createdAt: new Date(),
    id: 2,
    legalName: 'MexSmith S.A. de C.V.',
    logoUrl: 'https://picsum.photos/id/41/500',
    name: 'MexSmith',
    tags: ['featured'],
    updatedAt: new Date(),
  },
  {
    contacts: [{
      email: 'carlos.garcia@example.com',
      jobTitle: 'Sales Manager',
      lastName: 'García',
      name: 'Carlos',
      phoneNumber: '+1234567890',
    }],
    createdAt: new Date(),
    id: 3,
    legalName: 'Urbania Desarrollo S.A. de C.V.',
    logoUrl: 'https://picsum.photos/id/42/500',
    name: 'Urbania',
    tags: ['featured'],
    updatedAt: new Date(),
  },
  {
    contacts: [{
      email: 'maria.lopez@example.com',
      jobTitle: 'Sales Manager',
      lastName: 'López',
      name: 'María',
      phoneNumber: '+1234567890',
    }],
    createdAt: new Date(),
    id: 4,
    legalName: 'ViveCasa Residencial S.A. de C.V.',
    logoUrl: 'https://picsum.photos/id/43/500',
    name: 'ViveCasa',
    tags: ['featured'],
    updatedAt: new Date(),
  },
  {
    contacts: [{
      email: 'ana.ruiz@example.com',
      jobTitle: 'Sales Manager',
      lastName: 'Ruiz',
      name: 'Ana',
      phoneNumber: '+1234567890',
    }],
    createdAt: new Date(),
    id: 5,
    legalName: 'Altura Inmuebles S.A. de C.V.',
    logoUrl: 'https://picsum.photos/id/44/500',
    name: 'Altura',
    tags: ['featured'],
    updatedAt: new Date(),
  },
  {
    contacts: [{
      email: 'luis.hernandez@example.com',
      jobTitle: 'Sales Manager',
      lastName: 'Hernández',
      name: 'Luis',
      phoneNumber: '+1234567890',
    }],
    createdAt: new Date(),
    id: 6,
    legalName: 'NorteVivienda S.A. de C.V.',
    logoUrl: 'https://picsum.photos/id/45/500',
    name: 'NorteVivienda',
    tags: ['featured'],
    updatedAt: new Date(),
  },
  {
    contacts: [{
      email: 'sofia.martinez@example.com',
      jobTitle: 'Sales Manager',
      lastName: 'Martínez',
      name: 'Sofía',
      phoneNumber: '+1234567890',
    }],
    createdAt: new Date(),
    id: 7,
    legalName: 'CostaBrava Desarrollos S.A. de C.V.',
    logoUrl: 'https://picsum.photos/id/46/500',
    name: 'CostaBrava',
    tags: ['featured'],
    updatedAt: new Date(),
  },
  {
    contacts: [{
      email: 'diego.ramos@example.com',
      jobTitle: 'Sales Manager',
      lastName: 'Ramos',
      name: 'Diego',
      phoneNumber: '+1234567890',
    }],
    createdAt: new Date(),
    id: 8,
    legalName: 'PuntoCero Urbano S.A. de C.V.',
    logoUrl: 'https://picsum.photos/id/47/500',
    name: 'PuntoCero',
    tags: ['featured'],
    updatedAt: new Date(),
  },
  {
    contacts: [{
      email: 'elena.castro@example.com',
      jobTitle: 'Sales Manager',
      lastName: 'Castro',
      name: 'Elena',
      phoneNumber: '+1234567890',
    }],
    createdAt: new Date(),
    id: 9,
    legalName: 'Horizonte Living S.A. de C.V.',
    logoUrl: 'https://picsum.photos/id/48/500',
    name: 'Horizonte',
    tags: ['featured'],
    updatedAt: new Date(),
  },
  {
    contacts: [{
      email: 'pablo.mendez@example.com',
      jobTitle: 'Sales Manager',
      lastName: 'Méndez',
      name: 'Pablo',
      phoneNumber: '+1234567890',
    }],
    createdAt: new Date(),
    id: 10,
    legalName: 'TerraNova Residencial S.A. de C.V.',
    logoUrl: 'https://picsum.photos/id/49/500',
    name: 'TerraNova',
    tags: ['featured'],
    updatedAt: new Date(),
  },
];
